/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum GetActivitiesAdminStatusFilter {
  all = 'all',
  pending = 'pending',
  decided = 'decided'
}
